export default __webpack_public_path__ + "static/fa-brands-400-9aa66feee60e2e3bc69a3eeae78623a6.eot";